import React from 'react';
import { Spinner, Container, Row } from 'reactstrap';

function Spinners() {
  return (
    <Container fluid className="vh-100">
      <Row className="justify-content-center vh-100 align-items-center">
        <Spinner className="mx-3" type="grow" color="warning" />
        <Spinner className="mx-3" type="grow" color="warning" />
        <Spinner className="mx-3" type="grow" color="warning" />
      </Row>
    </Container>
  );
}

export default Spinners;
